module.exports = __webpack_public_path__ + "static/media/realtime-regular.ac054beb.woff";